<template>
  <div v-if="!isProductExcluded">
    <ValidationObserver ref="observer" v-slot="{ dirty, invalid }">
      <v-row>
        <v-col
          cols="12"
          :md="show5gRetail || isOriginal ? '4' : '6'"
          class="pt-0 pb-1"
        >
          <ValidationProvider
            name="Order Type"
            :rules="!isOriginal ? 'required' : ''"
            v-slot="{ errors }"
          >
            <v-combobox
              :items="type"
              label="Order Type"
              outlined
              placeholder=" "
              :clearable="!isOriginal"
              v-model="newOrder.orderType"
              :error-messages="errors"
              dense
              :disabled="is5G"
              :readonly="isOriginal"
              @change="emitData()"
              @input="updateValue('Order Type', newOrder.orderType)"
            ></v-combobox>
          </ValidationProvider>
        </v-col>
        <v-col
          cols="12"
          :md="show5gRetail ? '4' : '6'"
          class="pt-0 pb-1"
          v-if="show5gRetail"
        >
          <ValidationProvider
            name="UB Customer No."
            :rules="show5gRetail && !isOriginal ? 'required' : ''"
            v-slot="{ errors }"
          >
            <v-text-field
              v-if="isOriginal"
              v-model="newOrder.ubCustomerNumber"
              label="UB Customer No."
              placeholder=" "
              outlined
              dense
              :readonly="isOriginal"
            ></v-text-field>
            <v-autocomplete
              v-else
              :items="ubCustomers"
              label="UB Customer No."
              outlined
              placeholder=" "
              :clearable="!isOriginal"
              item-text="customerName"
              item-value="ubAccountNo"
              v-model="newOrder.ubCustomerNumber"
              :error-messages="errors"
              dense
              @change="emitData()"
              :filter="filterObject"
              :readonly="isOriginal"
              :search-input.sync="search"
            ></v-autocomplete>
          </ValidationProvider>
        </v-col>
        <v-col
          cols="12"
          :md="show5gRetail || isOriginal ? '4' : '6'"
          class="pt-0 pb-1"
          v-show="isOriginal"
        >
          <ValidationProvider name="Customer Reference">
            <v-text-field
              v-model="newOrder.customerReference"
              label="Customer Ref."
              placeholder=" "
              autocomplete="new"
              outlined
              dense
              @input="updatedReferences('custRef', newOrder.customerReference)"
              @change="checkValue()"
              readonly
            ></v-text-field>
          </ValidationProvider>
        </v-col>
        <v-col
          cols="12"
          :md="show5gRetail || isOriginal ? '4' : '6'"
          class="pt-0 pb-1"
        >
          <ValidationProvider
            name="Customer Auth Ref."
            :rules="
              !isOriginal
                ? 'required|custRef|isFirstCharValid|custRefLength'
                : ''
            "
            v-slot="{ errors }"
          >
            <v-text-field
              v-model="newOrder.customerAuthReference"
              label="Customer Auth Ref."
              placeholder=" "
              autocomplete="new"
              :error-messages="
                isDuplicate && (newOrder.customerAuthReference !== '' && newOrder.customerAuthReference !== null)
                  ? `${newOrder.customerAuthReference} already exist`
                  : errors
              "
              outlined
              dense
              @input="
                updatedReferences('authRef', newOrder.customerAuthReference)
              "
              @change="checkValue()"
              :readonly="isOriginal"
            ></v-text-field>
          </ValidationProvider>
        </v-col>
        <v-col
          cols="12"
          md="6"
          lg="4"
          class="pt-0 pb-1"
          v-show="showContactFields"
        >
          <ValidationProvider
            name="Contact Firstname"
            :rules="showContactFields && !isOriginal ? 'required' : ''"
            v-slot="{ errors }"
          >
            <v-text-field
              v-model="newOrder.contactFirstName"
              label="Contact Firstname"
              placeholder=" "
              autocomplete="new"
              :error-messages="errors"
              outlined
              dense
              @input="setName()"
              @change="emitData()"
              :readonly="isOriginal"
            ></v-text-field>
          </ValidationProvider>
        </v-col>
        <v-col
          cols="12"
          md="6"
          lg="4"
          class="pt-0 pb-1"
          v-show="showContactFields"
        >
          <ValidationProvider
            name="Contact Surname"
            :rules="showContactFields && !isOriginal ? 'required' : ''"
            v-slot="{ errors }"
          >
            <v-text-field
              v-model="newOrder.contactLastName"
              label="Contact Surname"
              placeholder=" "
              autocomplete="new"
              :error-messages="errors"
              outlined
              dense
              @input="setName()"
              @change="emitData()"
              :readonly="isOriginal"
            ></v-text-field>
          </ValidationProvider>
        </v-col>
        <v-col
          cols="12"
          md="6"
          lg="4"
          class="pt-0 pb-1"
          v-show="showContactFields"
        >
          <ValidationProvider
            name="Contact No."
            :rules="
              showContactFields && !isOriginal
                ? 'required|phonenumber|contact_no_length:10'
                : ''
            "
            v-slot="{ errors }"
          >
            <v-text-field
              v-model="newOrder.contactNumber"
              label="Contact No."
              maxlength="10"
              placeholder=" "
              autocomplete="new"
              :error-messages="errors"
              outlined
              dense
              @input="updateValue('CONTACT_NUMBER', newOrder.contactNumber)"
              @change="emitData()"
              :readonly="isOriginal"
            ></v-text-field>
          </ValidationProvider>
        </v-col>
        <v-col cols="12" md="6" lg="3" class="pt-0 pb-1">
          <ValidationProvider
            name="Customer Firstname"
            :rules="!isOriginal ? 'required' : ''"
            v-slot="{ errors }"
          >
            <v-text-field
              v-model="newOrder.customerFirstName"
              label="Customer Firstname"
              placeholder=" "
              autocomplete="new"
              :error-messages="errors"
              outlined
              dense
              @input="
                updateValue('CUSTOMER_FIRST_NAME', newOrder.customerFirstName)
              "
              @change="emitData()"
              :readonly="isOriginal"
            ></v-text-field>
          </ValidationProvider>
        </v-col>
        <v-col cols="12" md="6" lg="3" class="pt-0 pb-1">
          <ValidationProvider
            name="Customer Surname"
            :rules="!isOriginal ? 'required' : ''"
            v-slot="{ errors }"
          >
            <v-text-field
              v-model="newOrder.customerLastName"
              label="Customer Surname"
              placeholder=" "
              autocomplete="new"
              :error-messages="errors"
              outlined
              dense
              @input="
                updateValue('CUSTOMER_LAST_NAME', newOrder.customerLastName)
              "
              @change="emitData()"
              :readonly="isOriginal"
            ></v-text-field>
          </ValidationProvider>
        </v-col>
        <v-col cols="12" md="6" lg="3" class="pt-0 pb-0">
          <ValidationProvider
            name="Customer Email"
            :rules="!isOriginal ? 'required|email' : ''"
            v-slot="{ errors }"
          >
            <v-text-field
              v-model="newOrder.customerContactEmail"
              label="Customer Email"
              placeholder=" "
              autocomplete="new"
              :error-messages="errors"
              outlined
              dense
              @input="
                updateValue('Customer Email', newOrder.customerContactEmail)
              "
              @change="emitData()"
              :readonly="isOriginal"
            ></v-text-field>
          </ValidationProvider>
        </v-col>
        <v-col cols="12" md="6" lg="3" class="pt-0 pb-0">
          <ValidationProvider
            name="Customer Contact No."
            :rules="
              !isOriginal
                ? 'required|custcontactnumber|contact_no_length:10'
                : ''
            "
            v-slot="{ errors }"
          >
            <v-text-field
              v-model="newOrder.customerContactNumber"
              label="Customer Contact No."
              maxlength="10"
              placeholder=" "
              autocomplete="new"
              :error-messages="errors"
              outlined
              dense
              @input="
                updateValue(
                  'CUSTOMER_CONTACT_NUMBER',
                  newOrder.customerContactNumber
                )
              "
              @change="emitData()"
              :readonly="isOriginal"
            ></v-text-field>
          </ValidationProvider>
        </v-col>
        <v-col
          cols="12"
          :lg="show5gRetail ? '2' : '6'"
          class="pt-0 pb-1 custom-check"
          v-if="show5gRetail"
        >
          <ValidationProvider name="Retail" v-slot="{ errors }">
            <v-checkbox
              v-model="newOrder.isRetail"
              label="Retail"
              :error-messages="errors"
              @change="setRateplans"
              :readonly="isOriginal"
            ></v-checkbox>
          </ValidationProvider>
        </v-col>
        <v-col
          cols="12"
          :lg="show5gRetail ? '3' : '4'"
          :md="show5gRetail ? '4' : '6'"
          class="pt-0 pb-1"
          v-if="is5G"
        >
          <ValidationProvider
            name="Rate Plan"
            :rules="is5G && !isOriginal ? 'rateplanId' : ''"
            v-slot="{ errors }"
          >
            <v-autocomplete
              :items="ratePlans5G"
              label="Rate Plan"
              outlined
              placeholder=" "
              :error-messages="errors"
              dense
              v-model="newOrder.ratePlanID"
              item-text="ratePlanDescription"
              item-value="ratePlanID"
              @change="emitData()"
              :readonly="isOriginal"
            ></v-autocomplete>
          </ValidationProvider>
        </v-col>
        <v-col cols="12" md="6" lg="6" class="pt-0 pb-1" v-if="!is5G">
          <ValidationProvider
            name="Contract Length"
            :rules="!is5G && !isOriginal ? 'required' : ''"
            v-slot="{ errors }"
          >
            <v-combobox
              :items="contractLength.filter(x => (!is5G ? x !== '36' : x))"
              label="Contract Length"
              outlined
              placeholder=" "
              :clearable="!isOriginal"
              v-model="newOrder.contractTermLength"
              :error-messages="errors"
              dense
              @change="emitData()"
              @input="
                updateValue('Contract Length', newOrder.contractTermLength)
              "
              :readonly="isOriginal"
            >
              <template slot="selection" slot-scope="data">
                {{ data.item }}
                <span v-show="data.item !== 'M2M'" class="ml-1">months</span>
              </template>
            </v-combobox>
          </ValidationProvider>
        </v-col>

        <v-col cols="12" md="6" class="pt-0 pb-1" v-show="!is5G">
          <ValidationProvider
            name="AVCD Bandwidth Profile"
            :rules="!is5G && !isOriginal ? 'required' : ''"
            v-slot="{ errors }"
          >
            <v-combobox
              :items="bandwidth"
              label="AVCD Bandwidth Profile"
              outlined
              placeholder=" "
              :clearable="!isOriginal"
              v-model="newOrder.avcdBandwidthProfile"
              :error-messages="errors"
              :item-text="setText"
              dense
              @input="
                updateValue(
                  'AVCD_BANDWIDTH_PROFILE',
                  newOrder.avcdBandwidthProfile
                )
              "
              :readonly="isOriginal"
            >
              <template slot="item" slot-scope="data">
                {{
                  data.item.value === "12/1"
                    ? "Entry Level Bundle"
                    : data.item.value
                }}
              </template>
            </v-combobox>
          </ValidationProvider>
        </v-col>

        <v-col cols="12" class="py-0 mb-2">
          <v-divider class=""></v-divider>
        </v-col>

        <v-col cols="12" v-if="featureFlags.sog3814">
          <v-radio-group v-model="simMode" row :readonly="isOriginal">
            <v-radio label="Dispatch from 2SG" :value="true"></v-radio>
            <v-radio
              label="Activate from on hand stock"
              :value="false"
            ></v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="12" v-else></v-col>
        <v-col
          cols="12"
          :lg="show5gRetail ? '3' : '4'"
          :md="show5gRetail ? '4' : '6'"
          class="pt-0 pb-1"
          v-if="is5G"
        >
          <ValidationProvider
            name="MSN"
            :rules="is5G && !isOriginal ? 'required' : ''"
            v-slot="{ errors }"
          >
            <v-autocomplete
              label="MSN"
              :items="msnList"
              v-model="msnVal"
              placeholder=" "
              autocomplete="new"
              :error-messages="errors"
              outlined
              item-value="msn"
              item-text="msn"
              v-if="simMode"
              dense
              disabled
              @change="emitData()"
            ></v-autocomplete>
            <v-text-field
              v-else
              v-model="typed_msn"
              label="MSN"
              placeholder=""
              autocomplete="new"
              :error-messages="errors"
              outlined
              dense
              @change="emitData()"
            ></v-text-field>
          </ValidationProvider>
        </v-col>
        <v-col
          cols="12"
          lg="4"
          :md="show5gRetail ? '4' : '6'"
          class="pt-0 pb-1"
          v-if="is5G"
        >
          <ValidationProvider
            name="SIM No."
            :rules="is5G && !isOriginal ? 'required' : ''"
            v-slot="{ errors }"
          >
            <v-autocomplete
              v-if="simMode"
              label="SIM No."
              :items="simList"
              v-model="sim"
              placeholder=" "
              disabled
              autocomplete="new"
              :error-messages="errors"
              item-text="id"
              item-value="id"
              outlined
              dense
              @change="emitData()"
            ></v-autocomplete>
            <v-text-field
              v-else
              v-model="typed_sim"
              label="SIM No."
              placeholder=""
              autocomplete="new"
              :error-messages="errors"
              outlined
              dense
              @change="emitData()"
            ></v-text-field>
          </ValidationProvider>
        </v-col>

        <v-col cols="12" class="py-0">
          <v-divider></v-divider>
        </v-col>
        <v-col cols="12" class="custom-width">
          <v-checkbox
            v-model="newOrder.deliverToCustomer"
            label="Deliver to above Customer and Address"
            width="330px"
            @change="clearDeliveryDetail()"
            :readonly="isOriginal"
            v-if="is5G"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" lg="4" class="pt-0 pb-1" v-if="is5G">
          <ValidationProvider
            name="Delivery Address"
            :rules="is5G && !isOriginal ? 'required' : ''"
            v-slot="{ errors }"
          >
            <v-text-field
              v-model="newOrder.deliveryAddress"
              label="Delivery Address"
              placeholder=" "
              autocomplete="new"
              :error-messages="errors"
              outlined
              dense
              :readonly="isOriginal"
              :disabled="newOrder.deliverToCustomer"
              @change="emitData()"
            ></v-text-field>
          </ValidationProvider>
        </v-col>
        <v-col cols="12" lg="4" class="pt-0 pb-1" v-if="is5G">
          <ValidationProvider
            name="Delivery Contact Name"
            :rules="is5G && !isOriginal ? 'required' : ''"
            v-slot="{ errors }"
          >
            <v-text-field
              v-model="newOrder.deliveryContactName"
              label="Delivery Contact Name"
              placeholder=" "
              autocomplete="new"
              :error-messages="errors"
              outlined
              dense
              :disabled="newOrder.deliverToCustomer"
              :readonly="isOriginal"
              @change="emitData()"
            ></v-text-field>
          </ValidationProvider>
        </v-col>
        <v-col cols="12" lg="4" class="pt-0 pb-1" v-if="is5G">
          <ValidationProvider
            name="Delivery Contact Company"
            :rules="is5G && !isOriginal ? 'required' : ''"
            v-slot="{ errors }"
          >
            <v-text-field
              v-model="newOrder.deliveryContactCompany"
              label="Delivery Contact Company"
              placeholder=" "
              autocomplete="new"
              :error-messages="errors"
              outlined
              dense
              @change="emitData()"
              :readonly="isOriginal"
            ></v-text-field>
          </ValidationProvider>
        </v-col>
        <v-col v-show="showServiceId" cols="12" md="6" class="pt-0 pb-1">
          <ValidationProvider
            name="Service ID"
            :rules="showServiceId && !is5G ? 'required' : ''"
            v-slot="{ errors }"
          >
            <v-text-field
              v-model="newOrder.serviceId"
              label="Service ID"
              placeholder=" "
              autocomplete="new"
              :error-messages="errors"
              outlined
              dense
              @input="updateValue('SERVICE_ID', newOrder.serviceId)"
              :readonly="isOriginal"
            ></v-text-field>
          </ValidationProvider>
        </v-col>
      </v-row>
    </ValidationObserver>

    <technical-details
      :showTechDetails="showTechDetails"
      :fieldRequired="fieldRequired"
      @updateContact="updateContact"
      @cancelUpdate="cancelUpdate"
    ></technical-details>
  </div>
</template>

<script>
export default {
  name: "OrderDetails",
  props: {
    newOrder: { type: Object },
    ntd: { type: Array },
    unid: { type: Array },
    wholesalerAccount: { type: Number }
  },
  data: () => ({
    length: ["M2M", "12", "24", "36"],
    speed: [
      {
        text: "Entry Level Bundle",
        value: "12/1"
      },
      {
        text: "25/5",
        value: "25/5"
      },
      {
        text: "25/10",
        value: "25/10"
      },
      {
        text: "50/20",
        value: "50/20"
      },
      {
        text: "100/40",
        value: "100/40"
      },
      {
        text: "FW PLUS",
        value: "FW PLUS"
      }
    ],
    menu: false,
    date: null,
    isRadiusUsernameExisting: false,
    type: [
      { text: "Add", value: "Add", disabled: false },
      { text: "Transition", value: "Transition", disabled: false },
      { text: "Change", value: "Change", disabled: true },
      { text: "Transfer", value: "Transfer", disabled: false },
      { text: "Terminate", value: "Terminate", disabled: true }
    ],
    isCpiRequired: false,
    isNtdRequired: false,
    showMore: false,
    fttc: ["30", "31", "32", "33", "34"],
    fttp: ["1", "2", "3"],
    wireless: ["4", "5", "6"],
    hfc: ["21", "22", "23", "24"],
    fttb: ["10", "11", "12", "13"],
    workforce: ["Professional Install", "Self Install", "Not Required"],
    contractMonths: 0,
    showTechDetails: false,
    showContactError: false,
    deliverToCustomer: true,
    search: "all",
    installationClasses: ["12", "13", "23", "24", "31", "32", "33", "34"],
    simMode: true,
    typed_sim: "",
    typed_msn: ""
  }),
  mounted() {
    let vm = this;
    vm.newOrder.contactFirstName = vm.isAdmin || vm.isUserMember ? "2SG" : "";
    vm.newOrder.contactLastName =
      vm.isAdmin || vm.isUserMember ? "Support" : "";
    
    vm.newOrder.deliveryAddress = vm.newOrder.deliveryAddress || vm.fullAddress.formatted_address;
  },
  methods: {
    searchValue() {
      let vm = this;
      vm.getUBCustomers({
        id: vm.wholesalerAccount,
        keyword: vm.search
      });
    },
    displayOrder() {
      let vm = this;
    },
    filterObject(item, queryText) {
      return item.customerName !== undefined
        ? item.customerName
            .toLocaleLowerCase()
            .indexOf(queryText.toLocaleLowerCase()) > -1 ||
            item.ubAccountNo.toString().indexOf(queryText.toLocaleLowerCase()) >
              -1
        : "";
    },
    setRateplans() {
      let vm = this;
      vm.get5gRatePlans(!vm.newOrder.isRetail);
    },
    clearDeliveryDetail() {
      let vm = this;
      if (vm.newOrder.deliverToCustomer) {
        vm.newOrder.deliveryAddress = vm.fullAddress.formatted_address;
        vm.newOrder.deliveryContactName = `${vm.newOrder.customerFirstName} ${vm.newOrder.customerLastName}`;
      } else {
        vm.newOrder.deliveryAddress = "";
        vm.newOrder.deliveryContactName = "";
      }
    },
    cancelUpdate() {
      let vm = this;
      vm.showContactError = true;
      vm.showTechDetails = false;
    },
    updateContact(techDetails) {
      let vm = this;
      vm.$emit("updateContact", techDetails);
      vm.showContactError = false;
      vm.showTechDetails = false;
      vm.newOrder.deliveryAddress = techDetails.shipping.fullAddress;
    },
    setText(detail) {
      return detail.value === "12/1" ? "Entry Level Bundle" : detail.value;
    },
    checkValue() {
      let vm = this;
      vm.emitData();
      vm.getCustomerRefs5G(vm.newOrder.customerAuthReference).then(data => {
        vm.setIsDuplicate(data.length > 0);
      });
    },
    checkRequired() {
      let vm = this;
      vm.checkCpi();
      vm.checkNtd();
    },
    checkCpi() {
      let vm = this;

      if (
        vm.newOrder.orderType.value === "Transfer" &&
        (vm.isFttb || vm.isFttc)
      ) {
        vm.isCpiRequired = true;
        vm.newOrder.cpiId = "";
      } else vm.isCpiRequired = false;
    },
    checkNtd() {
      let vm = this;

      if (vm.newOrder.orderType.value === "Transfer") {
        vm.isNtdRequired = true;
        if (vm.isFttp || vm.isWireless) {
          vm.newOrder.ntdId = "";
          vm.newOrder.unidPortId = "";
        }
      } else vm.isNtdRequired = false;
    },
    createOffer() {
      let vm = this;
      vm.$emit("createOffer", vm.newOrder);
    },
    backToCreateOffer() {
      let vm = this;
      vm.showMore = false;
      vm.$emit("backToOffer");
    },
    updateValue(field, value) {
      let vm = this;

      if (vm.showMore) {
        if (field === "INSTALLATION_WORKFORCE") {
          if (value === "Self Install") vm.showTechDetails = true;
          else {
            vm.$emit("updateContact", {
              firstName: "2SG",
              lastName: "Support",
              number: "1800828668",
              email: "support@2sg.com.au"
            });
          }
        }

        if (field === "CPI_ID") {
          if (
            vm.formattedSQResult.serviceabilityClass === "13" &&
            vm.newOrder.orderType.value !== "Transfer"
          ) {
            let status = "";
            let hasCpi = false;

            vm.sqResult.parameters.parameterGroup.forEach(x => {
              if (x.groupName === vm.newOrder.cpiId) {
                x.parameter.forEach(y => {
                  if (y.name === "Copper Pair Status") {
                    status = y.value;
                    hasCpi = true;
                  }
                });
              }
            });

            if (status.toLowerCase() === "active" && hasCpi) {
              vm.newOrder.orderType = vm.type.filter(
                x => x.value === "Transition"
              )[0];
              vm.newOrder.unidslPotsInterconnect = "";
            } else {
              vm.newOrder.orderType = vm.type.filter(x => x.value === "Add")[0];
              vm.newOrder.unidslPotsInterconnect = "N/A";
            }

            vm.updateValue("Order Type", vm.newOrder.orderType);
            vm.updateValue(
              "UNIDSL_POTS_INTERCONNECT",
              vm.newOrder.unidslPotsInterconnect
            );
          }

          let cpi = vm.sqResult.parameters.parameterGroup.filter(
            x => x.groupName === value
          );

          let serviceClassCount = 0;
          cpi[0].parameter.forEach(x => {
            if (x.name === "ServiceabilityClass") serviceClassCount++;
          });

          if (serviceClassCount > 0) {
            let cpiClass = cpi[0].parameter.filter(
              x => x.name === "ServiceabilityClass"
            )[0].value;

            if (cpiClass === "31" || cpiClass === "32") {
              vm.$emit("updateWorkforce", "Professional Install");
            } else if (vm.isFttb) {
              if (
                vm.formattedSQResult.serviceabilityClass === "11" ||
                vm.formattedSQResult.serviceabilityClass === "12"
              )
                vm.$emit("updateWorkforce", "Professional Install");
              // else if (
              //   vm.hasInactive &&
              //   vm.formattedSQResult.serviceabilityClass === "13"
              // ) {
              //   vm.$emit("updateWorkforce", "Not Required");
              // }
              else vm.$emit("updateWorkforce", "Not Required");
            } else {
              vm.$emit("updateWorkforce", "");
            }
          }
        }

        if (field === "Radius Username") {
          if (
            vm.newOrder.radiusUsername === null ||
            vm.newOrder.radiusUsername.length <= 0 ||
            !vm.newOrder.radiusUsername.trim()
          )
            vm.isRadiusUsernameExisting = false;
          else {
            vm.checkRadiusUsername(vm.newOrder.radiusUsername).then(data => {
              vm.isRadiusUsernameExisting = data;
            });
          }
        }

        vm.updateCustomizedOffer({
          field: field,
          value: value
        });
      }
    },
    setName() {
      let vm = this;
      let firstName = vm.newOrder.contactFirstName;
      let lastName = vm.newOrder.contactLastName;

      vm.updateValue({
        field: "CONTACT_NAME",
        value: `${firstName} ${lastName}`
      });
    },
    updatedReferences(field, value) {
      let vm = this;
      vm.setIsDuplicate(false);
      let newValue = value.trim();

      if (field === "custRef") {
        vm.newOrder.customerReference = newValue;
      } else {
        vm.newOrder.customerAuthReference = newValue;
      }

      vm.updateValue(field, value);
    },
    nowDate() {
      return new Date().toISOString().slice(0, 10);
    },
    emitData() {
      let vm = this;
      if (vm.is5G) {
        let payload = {
          orderType: vm.newOrder.orderType,
          customerReference: vm.newOrder.customerReference,
          customerAuthReference: vm.newOrder.customerAuthReference,
          operatorContactEmail: vm.user.email,
          operatorContactNumber: vm.newOrder.contactNumber,
          operatorContactName: `${vm.newOrder.contactFirstName} ${vm.newOrder.contactLastName}`,
          customer: {
            firstName: vm.newOrder.customerFirstName,
            lastName: vm.newOrder.customerLastName,
            contactNo: vm.newOrder.customerContactNumber,
            email: vm.newOrder.customerContactEmail
          },
          contractLength: vm.setContractLength5G.toString(),
          WholesalerAccountNumber: 0,
          msisdn: vm.simMode ? vm.msnVal.msn : vm.typed_msn,
          usim: vm.simMode ? vm.sim.id : vm.typed_sim,
          accountNumber: "5G",
          sectorID: "",
          techType: "5G",
          uploadSpeed: "10",
          downloadSpeed: "50",
          ratePlanID: vm.newOrder.ratePlanID,
          deliveryContactCompany: vm.newOrder.deliveryContactCompany,
          deliveryAddress: vm.newOrder.deliveryAddress,
          deliveryContactName: vm.newOrder.deliveryContactName,
          deliverToCustomer: vm.newOrder.deliverToCustomer,
          isRetail: vm.newOrder.isRetail,
          ubCustomerNumber: vm.newOrder.ubCustomerNumber
            ? vm.newOrder.ubCustomerNumber.toString()
            : "0"
        };

        vm.sq5gResult.location.forEach(x => {
          x.mobileQualification.serviceSpecCharacteristics.forEach(y => {
            if (y.name === "SectorID") payload.sectorID = y.value;
          });
        });

        vm.$emit("emit5GData", payload);
      }
    }
  },
  computed: {
    // hasInactive() {
    //   let vm = this;
    //   let inactiveCount = 0;
    //   vm.sqResult.parameters.parameterGroup.forEach((x) => {
    //     x.parameter.forEach((y) => {
    //       if (
    //         y.name === "Copper Pair Status" &&
    //         y.value.toLowerCase() === "inactive"
    //       )
    //         inactiveCount++;
    //     });
    //   });
    //   return inactiveCount > 0;
    // },
    filteredWorkforce() {
      let vm = this;

      if (
        vm.formattedSQResult.serviceabilityClass === "23" ||
        vm.formattedSQResult.serviceabilityClass === "24"
      ) {
        return vm.hasFreePort
          ? vm.workforce
          : vm.workforce.filter(x => x !== "Self Install");
      } else if (vm.isFttb) {
        let fttbWorkforce = [];
        if (
          vm.formattedSQResult.serviceabilityClass === "11" ||
          vm.formattedSQResult.serviceabilityClass === "12"
        )
          fttbWorkforce = vm.workforce.filter(
            x => x === "Professional Install"
          );
        // else if (
        //   vm.hasInactive &&
        //   vm.formattedSQResult.serviceabilityClass === "13"
        // )
        //   fttbWorkforce = vm.workforce.filter((x) => x === "Not Required");
        // else fttbWorkforce = vm.workforce.filter((x) => x !== "Self Install");
        else fttbWorkforce = vm.workforce.filter(x => x === "Not Required");
        return fttbWorkforce;
      } else {
        if (
          vm.sqResult.parameters.parameterGroup &&
          vm.sqResult.parameters.parameterGroup.length > 0
        ) {
          let cpi = vm.sqResult.parameters.parameterGroup.filter(
            x => x.groupName === vm.newOrder.cpiId
          );

          if (cpi && cpi.length > 0) {
            let cpiClass = cpi[0].parameter.filter(
              x => x.name === "ServiceabilityClass"
            )[0].value;

            if (cpiClass === "31" || cpiClass === "32")
              return vm.workforce.filter(x => x === "Professional Install");
            else return vm.workforce;
          } else return vm.workforce;
        } else return vm.workforce;
      }
    },
    fieldRequired() {
      let vm = this;
      return vm.newOrder.installationWorkforce === "Self Install";
    },
    CpiOptions() {
      let vm = this;
      let result = [];
      if (vm.sqResult.parameters.parameterGroup != null) {
        vm.sqResult.parameters.parameterGroup.forEach(x => {
          result.push(x.groupName);
        });
      }
      return result;
    },
    ntdIdOptions() {
      let vm = this;
      let result = [];

      if (vm.sqResult.parameters.parameterGroup) {
        vm.sqResult.parameters.parameterGroup.forEach(x => {
          x.parameter.forEach(y => {
            if (
              y.name.includes("UNI-D") &&
              ((!vm.isOriginal
              ? vm.newOrder.orderType.value.toLowerCase() === "add"
              : vm.newOrder.orderType.toLowerCase() === "add")
                ? y.value.includes("Status=Free")
                : y.value.includes("Status=Used"))
            ) {
              if (!result.includes(x.groupName)) result.push(x.groupName);
            }
          });
        });
      }

      return result;
    },
    disableNext() {
      let vm = this;
      let validSq = false;

      if (vm.orderType === "nbn") {
        validSq =
          vm.sqResult.correlationId !== undefined &&
          !vm.sqResult.serviceability.includes("Rejected");
      }

      return (
        vm.locationID === "" ||
        vm.wholesalerAccount === 0 ||
        vm.isDuplicate ||
        !validSq
      );
    },
    setContractLength5G() {
      let vm = this;
      if (vm.newOrder.ratePlanID !== 0)
        return vm.ratePlans5G.filter(
          x => x.ratePlanID === vm.newOrder.ratePlanID
        )[0].contractMonths;
      else return 0;
    },
    formattedDate() {
      let vm = this;
      let dateArray = null;

      if (vm.newOrder.customerAuthDate) {
        let date = new Date(`${vm.newOrder.customerAuthDate}`);
        date = new Date(date.toString().replace("Standard", "Daylight"));
        let dateString = date.toLocaleDateString("en-GB");
        dateArray = dateString.split("/").reverse();
      }

      if (dateArray) return dateArray.join("/");
      else return null;
    },
    contractLength() {
      let vm = this;
      if (
        (vm.isFttc || vm.isFttb) &&
        vm.formattedSQResult.serviceabilityClasslength !== null
      )
        return vm.length.filter(x => x !== "6");
      else return vm.length;
    },
    bandwidth() {
      let vm = this;
      if (!vm.isWireless) return vm.speed.filter(x => x.value !== "FW PLUS");
      else if (vm.isWireless)
        return vm.speed.filter(
          x =>
            x.value !== "25/10" &&
            x.value !== "50/20" &&
            x.value !== "100/40" &&
            x.value !== "Entry Level Bundle"
        );
      else return vm.speed;
    },
    showContactFields() {
      let vm = this;
      if (!vm.isFttc) return true;
      else return false;
    },
    isFttb() {
      let vm = this;
      if (vm.fttb.includes(vm.formattedSQResult.serviceabilityClass))
        return true;
      else return false;
    },
    isFttc() {
      let vm = this;
      if (vm.fttc.includes(vm.formattedSQResult.serviceabilityClass))
        return true;
      else return false;
    },
    isFttp() {
      let vm = this;
      if (vm.fttp.includes(vm.formattedSQResult.serviceabilityClass))
        return true;
      else return false;
    },
    isWireless() {
      let vm = this;
      if (vm.wireless.includes(vm.formattedSQResult.serviceabilityClass))
        return true;
      else return false;
    },
    isHfc() {
      let vm = this;
      if (vm.hfc.includes(vm.formattedSQResult.serviceabilityClass))
        return true;
      else return false;
    },
    showFnn() {
      let vm = this;
      let show = null;
      if (vm.newOrder.orderType) {
        if (
          (vm.fttb || vm.fttc) &&
          vm.newOrder.orderType.value === "Transition"
        )
          show = true;
        else show = false;
      }

      return show;
    },
    showInstallationWorkforce() {
      let vm = this;
      if (
        vm.isFttb ||
        vm.installationClasses.includes(
          vm.formattedSQResult.serviceabilityClass
        )
      )
        return true;
      else return false;
    },
    showNtdID() {
      let vm = this;

      if (vm.isFttp || vm.isWireless || vm.isHfc) return true;
      else return false;
    },
    showUnidPort() {
      let vm = this;
      if (vm.hasNtd && (vm.isFttp || vm.isWireless || vm.isHfc)) return true;
      else return false;
    },
    isTransferRequired() {
      let vm = this;
      let required = false;
      if (vm.newOrder.orderType) {
        if (vm.newOrder.orderType.value === "Transfer" && vm.showMore)
          required = true;
      }
      return required;
    },
    showServiceId() {
      let vm = this;
      let show = false;
      if (vm.newOrder.orderType) {
        if (vm.newOrder.orderType.value === "Change") show = true;
      }
      return show;
    },
    contactName() {
      let vm = this;
      return `${vm.newOrder.contactFirstName} ${vm.newOrder.contactLastName}`;
    },
    is5G() {
      let vm = this;
      if (vm.orderType === "5g") return true;
      else return false;
    },
    show5gRetail() {
      let vm = this;
      return (
        vm.featureFlags.connect5GRetail &&
        vm.wholesalerAccount === 61596 &&
        vm.is5G
      );
    },
    hasVispCredentials() {
      let vm = this;
      return (
        vm.newOrder.radiusUsername !== null &&
        vm.newOrder.radiusPassword !== null &&
        vm.newOrder.radiusUsername !== "" &&
        vm.newOrder.radiusPassword !== ""
      );
    }
  },
  watch: {
    "newOrder.deliverToCustomer": function() {
      let vm = this;
      vm.$emit("deliverToCustomer", vm.newOrder.deliverToCustomer);
    },
    showMore: function() {
      let vm = this;
      if (vm.showMore) vm.$emit("displayOffer");
    },
    search: function() {
      let vm = this;
      vm.searchValue();
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-margin {
  margin-top: 48px;
}

.custom-check {
  ::v-deep .v-input--selection-controls {
    margin-top: 5px;
  }
}

.custom-width {
  ::v-deep .v-input__slot {
    width: 330px !important;
  }
}
</style>
